import { brandData } from '../data/brand-data.js';

export function renderOverviewView() {
  return `
    <section class="view-section" id="view-overview">
      <div class="hero-card">
        <span class="hero-tag">Brand Refresh Proposal</span>
        <h1>Urban Village Church</h1>
        <p style="max-width: 800px; font-size: var(--text-xl); color: #e2e8f0; margin-bottom: var(--space-lg);">
          A comprehensive brand strategy, demographic assessment, and three distinct brand concepts for Chicago's bold, inclusive, and relevant progressive faith community.
        </p>
        <div style="display: flex; gap: var(--space-md); flex-wrap: wrap;">
          <button class="nav-item-btn active" data-tab="concepts" style="width: auto; padding: var(--space-sm) var(--space-xl); background: var(--accent-primary); color: white; border-radius: var(--radius-full);">
            Explore Brand Concepts →
          </button>
          <button class="nav-item-btn" data-tab="assessment" style="width: auto; padding: var(--space-sm) var(--space-xl); background: var(--bg-surface-elevated); border-radius: var(--radius-full);">
            Read Brand Audit
          </button>
        </div>
      </div>

      <h3 style="margin-bottom: var(--space-lg);">Proposal Roadmap & Deliverable Modules</h3>
      <div class="grid-3" style="margin-bottom: var(--space-2xl);">
        <div class="card" style="cursor: pointer;" data-tab="assessment">
          <span class="mono" style="color: var(--accent-primary); font-size: var(--text-xs); font-weight: 700;">MODULE 01</span>
          <h4 style="margin: var(--space-xs) 0 var(--space-sm) 0; color: var(--text-primary);">Brand Assessment</h4>
          <p style="font-size: var(--text-xs); margin: 0;">Touchpoint audit across digital and Chicago sites, identifying brand equity, fragmentation, and SWOT factors.</p>
        </div>

        <div class="card" style="cursor: pointer;" data-tab="demographics">
          <span class="mono" style="color: var(--accent-primary); font-size: var(--text-xs); font-weight: 700;">MODULE 02</span>
          <h4 style="margin: var(--space-xs) 0 var(--space-sm) 0; color: var(--text-primary);">Demographic Intel</h4>
          <p style="font-size: var(--text-xs); margin: 0;">Neighborhood profiles (Wicker Park, Hyde Park, South Loop, Andersonville) and 5 target audience personas.</p>
        </div>

        <div class="card" style="cursor: pointer;" data-tab="strategy">
          <span class="mono" style="color: var(--accent-primary); font-size: var(--text-xs); font-weight: 700;">MODULE 03</span>
          <h4 style="margin: var(--space-xs) 0 var(--space-sm) 0; color: var(--text-primary);">Brand Strategy</h4>
          <p style="font-size: var(--text-xs); margin: 0;">Core purpose, competitive whitespace, modern value narrative, and tiered elevator pitch messaging framework.</p>
        </div>

        <div class="card" style="cursor: pointer;" data-tab="concepts">
          <span class="mono" style="color: var(--accent-primary); font-size: var(--text-xs); font-weight: 700;">MODULE 04</span>
          <h4 style="margin: var(--space-xs) 0 var(--space-sm) 0; color: var(--text-primary);">Three Brand Concepts</h4>
          <p style="font-size: var(--text-xs); margin: 0;">Three divergent visual and verbal identities: Bold Activism, Grounded Sanctuary, and Neo-Liturgical.</p>
        </div>

        <div class="card" style="cursor: pointer;" data-tab="comparison">
          <span class="mono" style="color: var(--accent-primary); font-size: var(--text-xs); font-weight: 700;">MODULE 05</span>
          <h4 style="margin: var(--space-xs) 0 var(--space-sm) 0; color: var(--text-primary);">Decision Matrix</h4>
          <p style="font-size: var(--text-xs); margin: 0;">Side-by-side comparative rubric evaluating concepts across mission alignment, audience resonance, and agility.</p>
        </div>

        <div class="card" style="background: rgba(99, 102, 241, 0.08); border-color: var(--border-accent);">
          <span class="mono" style="color: #a5b4fc; font-size: var(--text-xs); font-weight: 700;">WORKSPACE STATUS</span>
          <h4 style="margin: var(--space-xs) 0 var(--space-sm) 0; color: var(--text-primary);">Ready for Execution</h4>
          <p style="font-size: var(--text-xs); margin: 0;">All agent roles, directory structures, and presentation components are configured and synchronized.</p>
        </div>
      </div>
    </section>
  `;
}
